// import './header.scss';

import gsap from "gsap";

class Header {
	constructor() {
		this.burger = this.burger.bind(this);
		this.animInit = this.animInit.bind(this);

		this.DOM = document.querySelector("header");
		if (this.DOM) {
			this.init();
		}
	}
	init() {
		// this.sticky();
		this.burger();
		this.clickSelection();
	}

	sticky() {
		document.addEventListener("scroll", (e) => {
			const top = window.scrollY;
			if (top > 400) {
				this.DOM.classList.add("sticky");
			} else {
				this.DOM.classList.remove("sticky");
			}
		});
	}

	burger() {
		this.menuOpen = false;
		this.animInit();

		this.BURGER = this.DOM.querySelector(
			".menu-container__list__burger span"
		);
		this.BCK = this.DOM.querySelector(".menu-container__contents__bck");

		this.BURGER.addEventListener("click", (e) => {
			e.preventDefault();
			this.menuOpen = !this.menuOpen ? true : false;

			if (this.menuOpen) {
				this.reverse = false;
				this.tl.progress(0);
				this.tl.play();
			} else {
				this.reverse = true;
				this.tl.progress(1);
				this.tl.reverse();
			}
		});

		this.BCK.addEventListener("click", (e) => {
			e.preventDefault();

			this.reverse = true;
			this.tl.progress(1);
			this.tl.reverse();
		});
	}

	animInit() {
		this.tl = gsap.timeline({ paused: true });

		this.tl.add(() => {
			if (!this.reverse) {
				this.BURGER.classList.add("selected");
				this.DOM.classList.add("menu-open");
			} else {
				this.menuOpen = false;
				this.BURGER.classList.remove("selected");
				this.DOM.classList.remove("menu-open");
			}
		});

		this.tl.fromTo(
			"header .menu-container__contents li",
			{
				autoAlpha: 0,
				y: -5,
			},
			{
				y: 0,
				autoAlpha: 1,
				duration: 0.3,
				ease: "power2.inOut",
				stagger: {
					amount: 0.1,
				},
			},
			"<"
		);
	}

	clickSelection() {
		const allA = [
			...document.querySelectorAll(
				"header .menu-container__contents li a, .home .menu-container__contents a"
			),
		];
		const allAFiltredByText = allA.filter(
			(a) => a.innerText === "Sélection" || a.innerText === "Selection"
		);

		allAFiltredByText.forEach((a) => {
			a.addEventListener("click", (e) => {
				e.preventDefault();

				const url = e.target.href;

				if (window.location.href !== url) {
					localStorage.setItem("selection", "true");
					window.location.href = e.target.href;
				} else {
					const sectionSelection =
						document.querySelector("section.projects");

					let mobile = false;
					if (window.innerWidth <= 600) {
						mobile = true;
					}
					let index = Array.from(
						sectionSelection.parentNode.children
					).indexOf(sectionSelection);

					if (!mobile) {
						index = index - 1;
					}

					fp.moveTo(index);
					if(this.tl.progress() == 1){
						this.reverse = true;
						this.tl.progress(1);
						this.tl.reverse();
					}


				}
			});
		});

		// if (allAFiltredByText) {
		// 	allAFiltredByText.addEventListener("click", (e) => {
		// 		e.preventDefault();

		// 		const url = e.target.href;

		// 		if (window.location.href !== url) {
		// 			localStorage.setItem("selection", "true");
		// 			window.location.href = e.target.href;
		// 		} else {
		// 			const sectionSelection =
		// 				document.querySelector("section.projects");
		// 			const index =
		// 				Array.from(
		// 					sectionSelection.parentNode.children
		// 				).indexOf(sectionSelection) - 1;

		// 			fp.moveTo(index);
		// 			this.reverse = true;
		// 			this.tl.progress(1);
		// 			this.tl.reverse();
		// 		}
		// 	});
		// }
	}

	stop() {}
}

export default new Header();
